import withNavigationTheme from '../../hooks/withNavigationTheme';
import TopNavigationSidebarProductHeader from './TopNavigationSidebarProductHeader';

export default withNavigationTheme(TopNavigationSidebarProductHeader);
